import { createFileRoute } from '@tanstack/react-router';
import { JourneysIntegrationsHandoff } from '@/pages/workspaces/integrations/routing';

function JourneysIntegrationsOverviewRoute() {
  return <JourneysIntegrationsHandoff target="overview" />;
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/integrations/all/overview')({
  component: JourneysIntegrationsOverviewRoute,
});
